import { type Components, type Theme } from "@mui/material";
import { CUSTOM_ELEVATIONS } from "Theme/Shadows";

export const MuiDialog: Components<Theme>["MuiDialog"] = {
  styleOverrides: {
    paper: () => ({
      boxShadow: CUSTOM_ELEVATIONS.default,
    }),
  },
};
